import React, { Component } from "react"
import Layout from "../components/layout"
import SEO from "../components/seo"
import AOS from "aos"
import "aos/dist/aos.css"
import NewsStrip from "../components/news-strip"
import MetroFares from "../components/metro-fares"

class MM2ServicePage extends Component {
  componentDidMount() {
    AOS.init()
    window.addEventListener("load", AOS.refresh)
    // @NOTE: Hack to force AOS to work :(
    window.setTimeout(AOS.refresh, 1000)
  }

  componentDidUpdate() {
    AOS.refresh()
  }

  render() {
    return (
      <Layout>
        <SEO
          title="MM2"
          description="View route information and buy your ticket for the MM2 service operated by Tetley's Coaches."
        />
        <div className="block-services inner-body-bg">
          <div className="body gutter page-content-parent">
            <div className="text-center">
              <h1 className="page-content-heading">MM2 service</h1>
              <p>Fairfield Mount - Mount St Mary's</p>
              <p>Mount St Mary's – Fairfield Mount</p>
            </div>
          </div>

          <div className="body gutter page-content-parent">
            <div className="page-content">
              <div className="page-content__text">
                <h2>Route</h2>
                <p style={{ margin: '15px 0'}}>This service will pick up/set down at all regular bus stops along the following route:</p>
                <h3 style={{ margin: '10px 0'}}>AM route</h3>
                <iframe
                  title="MM2 AM route map"
                  className="route-map"
                  src="https://www.google.com/maps/d/embed?mid=1-dzHeDGwfY6yJmRTzh2KJl0xxphxgks&ehbc=2E312F"
                  width="100%"
                  height="480"
                ></iframe>
                <p>
                  <strong>Towards</strong> Mount St Mary's
                </p>
                <p>
                  Stanningley Road, Lower Town Street, Waterloo Lane, Raynville Road, Armley Ridge
Road, Cockshott Lane, Stanningley Road, Green Hill Road, Hill Top Road, Whingate,
Upper Wortley Road, Dixon Lane, Whitehall Road, Domestic Road, Domestic Street,
Top Moor Side, Cemetery Road, Beeston Road, Malvern Road, Lady Pit Lane,
Hunslet Hall Road, Dewsbury Road, Tunstall Road, A61, South Accommodation
Road, Cross Green Lane, Ellerby Lane.
                </p>

                <h3 style={{ margin: '10px 0'}}>PM route</h3>
                <iframe
                  title="MM2 PM route map"
                  className="route-map"
                  src="https://www.google.com/maps/d/embed?mid=19cTMp1uBmgkNTfnTM_2OOjtqa_gaB7E&ehbc=2E312F"
                  width="100%"
                  height="480"
                ></iframe>
                <p>
                  <strong>From</strong> Mount St Mary's
                </p>
                <p>
                  Ellerby Lane, Dial Street, Easy Road, Cross Green Lane, South Accommodation
Road, Tunstall Road, Dewsbury Road, Hunslet Hall Road, Lady Pit Lane, Malvern
Road, Beeston Road, Cemetery Road, Top Moor Side, Domestic Street, Domestic
Road, Whitehall Road, Dixon Lane, Upper Wortley Road, Whingate, Hill Top Road,
Green Hill Road, Stanningley Road, Cockshott Lane, Armley Ridge Road, Raynville
Road, Waterloo Lane, Lower Town Street, Stanningley Road.
                </p>
              </div>
              <div className="page-content__text">
                <h2>Timetable</h2>
                <table className="timetable">
                  <thead>
                    <tr>
                      <th colSpan="3">Morning</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Fairfield Mount</td>
                      <td>DEP</td>
                      <td>0715</td>
                    </tr>
                    <tr>
                      <td>Raynville Road at Landseer Avenue</td>
                      <td>DEP</td>
                      <td>0725</td>
                    </tr>
                    <tr>
                      <td>Hill Top Road at Heights Lane</td>
                      <td>DEP</td>
                      <td>0735</td>
                    </tr>
                    <tr>
                      <td>Dixon Lane at Kellett Road</td>
                      <td>DEP</td>
                      <td>0745</td>
                    </tr>
                    <tr>
                      <td>Beeston Medical Centre</td>
                      <td>DEP</td>
                      <td>0800</td>
                    </tr>
                    <tr>
                      <td>Hunslet Hall Road</td>
                      <td>DEP</td>
                      <td>0805</td>
                    </tr>
                    <tr>
                      <td>Mount St Mary's School</td>
                      <td>ARR</td>
                      <td>0820</td>
                    </tr>
                  </tbody>
                </table>


                <table className="timetable">
                  <thead>
                    <tr>
                      <th colSpan="3">Afternoon</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Mount St Mary's School</td>
                      <td>DEP</td>
                      <td>1520</td>
                    </tr>
                    <tr>
                      <td>Hunslet Hall Road</td>
                      <td>DEP</td>
                      <td>1535</td>
                    </tr>
                    <tr>
                      <td>Dixon Lane at Kellett Road</td>
                      <td>DEP</td>
                      <td>1545</td>
                    </tr>
                    <tr>
                      <td>Hill Top Road at Heights Lane</td>
                      <td>DEP</td>
                      <td>1555</td>
                    </tr>
                    <tr>
                      <td>Raynville Road at Landseer Avenue</td>
                      <td>DEP</td>
                      <td>1605</td>
                    </tr>
                    <tr>
                      <td>Fairfield Mount</td>
                      <td>ARR</td>
                      <td>1615</td>
                    </tr>
                  </tbody>
                </table>



                <MetroFares />
              </div>
            </div>
          </div>
        </div>

        <NewsStrip />
      </Layout>
    )
  }
}

export default MM2ServicePage
